const $ = require('cash-dom');
const {Cash} = require("cash-dom");

let instance = null;

/**
 * Class Popup Is singleton.
 *
 * Usage:
 * ```
 * const popup = require('path/to/popup');
 *
 * popup.show('some html content as string');
 *
 * // with options
 * popup.show('some html', {className: 'some-class', width: '90vw', height: '90vh'})
 * // className will be set to .popup-container
 * // width and height will be set to .popup-content as css properties
 *
 * // to hide popup:
 * popup.hide();
 * ```
 *
 * Special classes. You can use one of predefined css classes:
 * ```
 * popup.show('some html', {className: 'template-popup'}); // adds border radius, paddings and $white background
 * popup.show('some html', {className: 'simple-template-popup'}); // adds just $white background
 * ```
 */
class Popup {
  constructor() {
    if (!instance) {
      this._Popup = $('#main-pp');
      this._popupContainer = this._Popup.find('.popup-container');
      this._popupContent = this._popupContainer.find('.popup-content');

      this._defaultShowOptions = {
        className: 'template-popup',
        align: 'center',
        backgroundLayer: true
      };

      this._handleKeyup = (e) => {
        const isEscape = ('key' in e) ? e.key === 'Escape' || e.key === 'Esc' : e.keyCode === 27;

        if (isEscape) {
          this.hide();
        }
      }

      this._init();

      instance = this;
    }

    return instance;
  }

  _init() {
    this._Popup.on('click', (e) => {
      if (!e.isPopupContentClick) {
        this.hide();
        e.isPopupContentClick = false;
      }
    });

    this._Popup.find('.popup-container').on('click', (event) => {
      event.isPopupContentClick = true;
    });
  }

  _attachPopupCloseHandling() {
    this._Popup.find('.popup-close').on('click', (e) => {
      e.preventDefault();
      this.hide();
    });
  }

  hide() {
    this._Popup.hide();
    $(document).off('keyup', this._handleKeyup);
  }

  /**
   * Shows popup for Cash (tiny jQuery) object.
   * The purpose is to preserve object's (element's) events and inline styles.
   * @param {Cash} $cashElement
   * @param {{className: string|undefined, width: string|undefined, height: string|undefined,backgroundLayer: bool|undefined}} options If you are
   * overriding the className, please add class `simple-template-popup` to have white background.
   */
  showForCashObject($cashElement, options = {}) {
    options = Object.assign({className: 'simple-template-popup'}, options);
    this.show('', options);
    $cashElement.appendTo('#popup .popup-content');
    this._attachPopupCloseHandling();
  }

  /**
   * Shows html content inside popup.
   * Usage:
   * ```
   * const popup = require('./popup');
   *
   * popup.show({html: '<div>Some content</div>'});
   * ```
   * @param {string} html
   * @param {{className: string|undefined, width: string|undefined, height: string|undefined, align: string|undefined}} options
   * Note: add 'template-popup' if you override default className and need white background
   */
  show(html, options = {}) {
    options = Object.assign(this._defaultShowOptions, options);
    this._applyOptions(options);

    this._popupContent.html(html);

    this._showPopupElement();
    this._attachPopupCloseHandling();

    $(document).on('keyup', this._handleKeyup);
  }

  _applyOptions(options) {
    this._clearOptions();

    if (options.className) {
      this._popupContainer.addClass(options.className);
    }

    if (options.width) {
      this._popupContent.css('width', options.width);
    }

    if (options.height) {
      this._popupContent.css('height', options.height);
    }

    if (options.align) {
      if (options.align === 'top') {
        this._Popup.addClass('popup-align-top');
      } else if (options.align === 'bottom') {
        this._Popup.addClass('popup-align-bottom');
      }
    }

    if (options.backgroundLayer === false) {
      this._Popup.addClass("popup-no-bg-layer");
    }


  }

  _clearOptions() {
    // remove all classes
    this._popupContainer.removeClass();
    // add permanent class
    this._popupContainer.addClass('popup-container');

    this._popupContainer.removeAttr('style');
  }

  _showPopupElement() {
    this._Popup.css('display', 'flex');
  }
}

module.exports = new Popup();
